import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { from, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';

@Component({
  selector: 'app-link-group-modal',
  templateUrl: './link-group-modal.component.html',
  styleUrls: ['./link-group-modal.component.scss'],
})
export class LinkGroupModalComponent implements OnDestroy {
  siteGroupId: any;
  siteGroupName: any;

  form: FormGroup = this.formBuilder.group({
    siteGroupOptions: [null],
    siteGroupId: [null],
    siteGroupName: [null],
  });

  private subscriptions = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LinkGroupModalComponent>,
    private errorHandlingService: ErrorHandlingService,
    private formBuilder: FormBuilder,
    @Inject('sites') private sites: any,
    @Inject('siteGroups') private siteGroups: any,
    @Inject('sitesMap') private sitesMap: any,
    @Inject('siteGroupsMap') private siteGroupsMap: any,
    @Inject('SitesGroupFactory') private sitesGroupService: any
  ) {
    this.subscriptions.add(
      this.form.get('siteGroupOptions').valueChanges.subscribe(value => {
        switch (value) {
          case 'no-group':
            this.form.get('siteGroupName').disable();
            this.form.get('siteGroupName').clearValidators();
            this.form.get('siteGroupId').disable();
            this.form.get('siteGroupId').clearValidators();
            break;
          case 'select-group':
            this.form.get('siteGroupName').disable();
            this.form.get('siteGroupName').clearValidators();
            this.form.get('siteGroupId').enable();
            this.form.get('siteGroupId').setValidators([Validators.required]);
            break;
          case 'create-group':
            this.form.get('siteGroupName').enable();
            this.form.get('siteGroupName').setValidators([Validators.required]);
            this.form.get('siteGroupId').disable();
            this.form.get('siteGroupId').clearValidators();
            break;
        }
        this.form.get('siteGroupName').updateValueAndValidity();
        this.form.get('siteGroupId').updateValueAndValidity();
      })
    );
    this.form.patchValue({
      siteGroupOptions: 'no-group',
    });
  }

  connectLocationsWithSiteGroupId() {
    const { siteGroupOptions, siteGroupId, siteGroupName } = this.form.getRawValue();
    if (this.form.get('siteGroupName').valid && siteGroupName) {
      from(this.sitesGroupService.createSiteGroup(this.data.companyId, siteGroupName, this.data.siteType))
        .pipe(
          tap(() =>
            this.siteGroups.refresh().then(() => {
              this.siteGroupsMap.refresh();
              this.sites.refresh().then(() => {
                this.sitesMap.refresh();
              });
            })
          ),
          this.errorHandlingService.catchAlertAndThrowHttpError()
        )
        .subscribe({
          next: (response: any) => {
            this.selectGroupId(response.data.id);
          },
          error: console.log,
        });
    } else if (siteGroupOptions === 'no-group') {
      this.selectGroupId(0);
    } else {
      this.selectGroupId(siteGroupId);
    }
  }

  private selectGroupId(siteGroupId: number) {
    this.dialogRef.close({ siteGroupId });
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }
}
